import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import Link from '@cotyorg/ccx-atoms/Link';

const EmptyBasket = ({ heading, subheading, link }) => (
  <div className="shopping-bag shopping-bag--empty">
    <Heading level={1} extraClass="uppercase">
      {heading}
    </Heading>
    <Paragraph>{subheading}</Paragraph>

    <Link
      extraClass="button button--primary"
      link={R.prop('url', link)}
      target={R.prop('openInNewWindow', link) ? '_blank' : '_self'}
      title={R.prop('text', link)}
    >
      {R.prop('text', link)}
    </Link>
  </div>
);

EmptyBasket.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  link: PropTypes.shape({
    url: PropTypes.string,
    openInNewWindow: PropTypes.bool,
    text: PropTypes.string,
  }),
};

export default EmptyBasket;
